import { create } from 'zustand'
import { VariantName } from '../../components/modals-services-provider/constants'

interface ModalPlansState {
  isOpen: boolean
  variantName?: VariantName | undefined
  setIsOpen: ({
    isOpen,
    variantName
  }: {
    isOpen: boolean
    variantName?: VariantName | undefined
  }) => void
  setVariantName: (variantName: VariantName) => void
  reset: () => void
}

const initialState = {
  isOpen: false,
  variantName: undefined
}

export const useModalPlansStore = create<ModalPlansState>()((set) => ({
  ...initialState,
  setIsOpen: ({ isOpen, variantName }) => set({ isOpen, variantName }),
  setVariantName: (variantName) => set({ variantName }),
  reset: () =>
    set({
      ...initialState
    })
}))
